import React from 'react';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

export const Skeleton = (): React.JSX.Element => (
	<Stack space="space.100" grow="hug">
		<Box xcss={headingSkeleton} />
		<Box xcss={dropdownSkeleton} />
	</Stack>
);

const LazyPageSwitcher = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-global-settings-page-switcher" */ './main'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: false,
	},
);

export const AsyncPageSwitcher = (props: Props): React.JSX.Element => (
	<Placeholder name="nav4.sidebar.global-settings.page-switcher" fallback={<Skeleton />}>
		<LazyPageSwitcher {...props} />
	</Placeholder>
);

const headingSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	width: '50%',
	height: token('space.200'),
	borderRadius: 'radius.small',
});

const dropdownSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.400'),
	borderRadius: 'radius.small',
});
